<template>
  <div>
    <div v-if="isLoading">
      Loading ...
    </div>


    <div v-if="!authenticated && !isPublicPage" class="social-login-button">
      <div v-if="!isLoading">
        <b-form @submit="login" class="vertical-center">
          <h2>LXL Atlas</h2>

          <b-form-group id="input-group-1" label="Email:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="form.email"
              type="email"
              required
            ></b-form-input>
          </b-form-group>

          <b-form-group id="input-group-2" label="Password:" label-for="input-2">
            <b-form-input
              id="input-2"
              v-model="form.password"
              required
              type="password"
            ></b-form-input>
          </b-form-group>

          <b-button type="submit" variant="primary" v-if="!isLoading">Đăng nhập</b-button>
          <p class="" v-if="isLoading">Đang đăng nhập</p>

          <p class="login-message">{{ message }}</p>
        </b-form>
      </div>
    </div>

    <div v-else>
      <router-view :key="$route.path"></router-view>
    </div>
  </div>
</template>

<script>
import Firebase from "./services/firebase.js";

export default {
  name: "App",
  metaInfo: {
    // Global meta tags that can be overridden by child components
    titleTemplate: '%s | LXL Atlas',
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }
    ]
  },
  computed: {
    authenticated() {
      return this.loggedIn;
    },
    isPublicPage() {
      return this.$route.path=='/contact-form' || 
             this.$route.path=='/contact-form-gc' || 
             this.$route.path.startsWith('/public-product');
    }
  },
  data() {
    return {
      loggedIn: false,
      form: {
        email: "",
        password: "",
      },
      message: "",
      isLoading: false
    };
  },

  methods: {
    async login() {
      this.isLoading = true;
      var data = null;

      try {
        data = await Firebase.login(this.form.email, this.form.password);
        console.log('Login with firebase ', data);
      }
      catch(e) {
        this.loggedIn = false;
        this.message = "Không thể đăng nhập!";
        this.isLoading = false;
        console.log(e.message);
        return;
      }

      // try to get user role
      this.getUserRole(data.user.email);

      this.isLoading = false;
      this.loggedIn = true;
    },

    async getUserRole (email, nextFunc) {
      console.log('App::getUserRole::trying to get user role');
      var db = Firebase.getFirestore();
      var userRef = db.collection("users").doc(email);
      var userRole = "sale"; // default role for user
      var accept = ["product"]; // default accept for user
      var permissions = [];
      var access_control_type = 'role'; // use role based access control by default, otherwise use permission based
      var salename = "";

      try {
        var userInfo = await userRef.get();
        if (userInfo.exists) {
          console.log("App::getUserRole::userInfo data:", userInfo.data());
          userRole = userInfo.data().role; // use this to hide/show information for firebase
          accept = userInfo.data().accept;
          permissions = userInfo.data().permissions;
          access_control_type = userInfo.data().access_control_type;
          salename = userInfo.data().salename;
          var permissionMap = {};

          if(permissions){
            permissionMap = permissions.reduce((obj, currentString, index) => {
              obj[currentString] = true; // Assign index or any value you prefer
              return obj;
            }, {});
          }

          this.$store.commit('set', ['userRole',userRole]);
          this.$store.commit('set', ['userEmail',email]);
          this.$store.commit('set', ['accept',accept]);
          this.$store.commit('set', ['permissions',permissionMap]);
          this.$store.commit('set', ['access_control_type',access_control_type]);
          this.$store.commit('set', ['salename',salename]);
        } else {
            // doc.data() will be undefined in this case
            console.log("App::getUserRole::No such user!");
        }
      }
      catch(error) {
        console.log("App::getUserRole::Error getting userInfo:", error);
      };

      // Check if nextFunc is a function and, if so, invoke it
      if (typeof nextFunc === 'function') {
        nextFunc();
      }

      this.$store.commit('set', ['userRole',userRole]);
      this.$store.commit('set', ['userEmail',email]);
      this.$store.commit('set', ['accept',accept]);
      
      console.log("App::getUserRole::role committed: ", this.$store);
    }
  },
  mounted() {
    this.isLoading = true;
    this.loggedIn = false;
    console.log('App::mounted');

    Firebase.auth.onAuthStateChanged( user => {
      if (user) {
        // this.user.data = user;
        
        this.getUserRole(user.email, nextFunc => {
          this.isLoading = false;
          this.loggedIn = true;
          // this.$router.push('/v2/products');

        });
        
        return;
      }

      this.loggedIn = false;
      this.isLoading = false;
    })
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";

.social-login {
  height: 300px;
  position: relative;
}

.vertical-center {
  width: 300px;
  margin: 0;
  position: absolute;
  top: 20%;
  left: 30%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.login-message {
  margin-top: 20px;
  color: red;
}

@media (min-width: 992px) {
.c-sidebar {
  width: 200px !important;
}
.c-wrapper {
  margin-left: 200px !important;
}
}

/* Mobile improvements - work with CoreUI responsive behavior */
@media (max-width: 768px) {
  /* Better mobile spacing for main content */
  .c-main .container-fluid {
    padding-left: 10px;
    padding-right: 10px;
  }
  
  /* Improve mobile forms */
  .form-control {
    font-size: 16px; /* Prevents zoom on iOS */
  }
  
  /* Better mobile buttons */
  .btn {
    min-height: 44px; /* Better touch target */
  }
  
  .btn-sm {
    min-height: 36px;
  }
  
  /* Ensure sidebar doesn't interfere with main content on mobile */
  .c-sidebar-show .c-wrapper {
    margin-left: 0 !important;
  }
}

@media (max-width: 576px) {
  .c-main .container-fluid {
    padding-left: 5px;
    padding-right: 5px;
  }
  
  /* Better mobile table handling */
  .table-responsive {
    border: none;
  }
  
  /* Improve mobile card spacing */
  .card {
    margin-bottom: 1rem;
  }
}
</style>
